import SlimSelect from 'slim-select';

export default class FilterSelectController {

  constructor() {
    if ($('.js-news-filter-company').length && $('.js-news-filter-categories').length && $('.js-news-filter-year').length) {
      this.initSelectNews();
    }

    if ($('.js-blog-filter-categories').length) {
      this.initSelectBlog();
    }
  }

  initSelectNews() {
    console.log('init news');
    const selectCompany: HTMLElement | null = document.querySelector('.js-news-filter-company');
    const selectCategory: HTMLElement | null = document.querySelector('.js-news-filter-categories');
    const selectYear: HTMLElement | null = document.querySelector('.js-news-filter-year');

    if (!selectCompany || !selectCategory || !selectYear) {
      return;
    }

    const filterSelectCompany = new SlimSelect({
      select: selectCompany,
      showSearch: false,
    });
    filterSelectCompany.setSelected(selectCompany.dataset.selected || 'all');

    const filterSelectCategory = new SlimSelect({
      select: selectCategory,
      showSearch: false,
    });
    filterSelectCategory.setSelected(selectCategory.dataset.selected || 'all');

    const filterSelectYear = new SlimSelect({
      select: selectYear,
      showSearch: false,
    });
    filterSelectYear.setSelected(selectYear.dataset.selected || 'all');

    selectCompany.addEventListener('change', () => {
      const selectedOption: HTMLElement | null = selectCompany.querySelector('option[value=\"' + filterSelectCompany.selected() as string + '\"]');
      if (!selectedOption) {
        return;
      }
      window.location.href = selectedOption.dataset.link || '';
    });

    selectCategory.addEventListener('change', () => {
      const selectedOption: HTMLElement | null = selectCategory.querySelector('option[value=\"' + filterSelectCategory.selected() as string + '\"]');
      if (!selectedOption) {
        return;
      }
      window.location.href = selectedOption.dataset.link || '';
    });

    selectYear.addEventListener('change', () => {
      const selectedOption: HTMLElement | null = selectYear.querySelector('option[value=\"' + filterSelectYear.selected() as string + '\"]');
      if (!selectedOption) {
        return;
      }
      window.location.href = selectedOption.dataset.link || '';
    });
  }

  initSelectBlog() {
    const select: HTMLElement | null = document.querySelector('.js-blog-filter-categories');
    if (!select) {
      return;
    }

    const filterSelectCategory = new SlimSelect({
      select: select,
      showSearch: false,
    });
    filterSelectCategory.setSelected(select.dataset.selected || 'all');

    select.addEventListener('change', () => {
      const selectedOption: HTMLElement | null = select.querySelector('option[value=\"' + filterSelectCategory.selected() as string + '\"]');
      if (!selectedOption) {
        return;
      }
      window.location.href = selectedOption.dataset.link || '';
    });
  }
}
